import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

export const parseBRL = (s) => {
  if (typeof s === "number") return s;
  let t = String(s || "").replace(/[^\d.,]/g, "");
  if (!t) return 0;
  if (t.includes(",")) t = t.replace(/\./g, "").replace(",", ".");
  else if ((t.match(/\./g) || []).length > 1 || /\.\d{3}$/.test(t)) t = t.replace(/\./g, "");
  const n = parseFloat(t);
  return isNaN(n) ? 0 : Math.round(n * 100) / 100;
};
export const fmtBRL = (n) => (Number(n) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const fmtPlain = (n) => (Number(n) ? Number(n).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "");

export const CurrencyInput = ({ value, onChange, className = "", testid, autoFocus }) => {
  const [text, setText] = useState(fmtPlain(value));
  const [focus, setFocus] = useState(false);
  const small = className.includes("h-11");
  useEffect(() => { if (!focus) setText(fmtPlain(value)); }, [value, focus]);
  return (
    <div className="relative">
      <span className={`absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground font-bold pointer-events-none ${small ? "text-sm" : "text-lg font-display left-4"}`}>R$</span>
      <Input inputMode="decimal" autoFocus={autoFocus} value={text} data-testid={testid} placeholder="0,00"
        onFocus={() => setFocus(true)}
        onBlur={() => { setFocus(false); setText(fmtPlain(parseBRL(text))); }}
        onChange={(e) => { const v = e.target.value.replace(/[^\d.,]/g, ""); setText(v); onChange(parseBRL(v)); }}
        className={small ? `${className} pl-9` : "h-14 pl-12 text-2xl font-display font-bold"} />
    </div>
  );
};
